import { Icon } from '@liveconnect/icons'
import { ColumnDef } from '@tanstack/react-table'
import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import ContentTable from '../../../../components/ContentTable'
import {
  LiveconnectUserDetail,
  LiveConnectUserSignedItem,
} from '../../../../core/liveconnect/types'
import useLiveconnect from '../../../../core/liveconnect/useLiveconnect'
import useCulture from '../../../../utils/culture'

import './styles.scss'

const LCTPrivacy = () => {
  const { t } = useTranslation()
  const { detail } = useLiveconnect()
  const { formatDate } = useCulture()

  const { privacyPoliciesSigned, lastPrivacyPolicyVersionSigned } =
    detail as LiveconnectUserDetail

  const columns: ColumnDef<LiveConnectUserSignedItem>[] = useMemo(
    () => [
      {
        accessorKey: 'code',
        header: t('liveconnect.detail.termscons.header.code'),
      },
      {
        accessorKey: 'signDate',
        header: t('liveconnect.detail.termscons.header.date'),
        cell: ({ row }) =>
          formatDate(new Date(row.original.signDate) as Date, 'LONG_DATE_TIME'),
      },
    ],
    []
  )

  return (
    <div className="LCTermsCons">
      <h4>{t('liveconnect.detail.privacy.title')}</h4>
      <p>{t('liveconnect.detail.privacy.hint')}</p>
      {!lastPrivacyPolicyVersionSigned && (
        <div className="LCTermsCons__error">
          <div className="d-flex align-items-center">
            <div className="LCTermsCons__error__icon">
              <Icon name="report_problem" />
            </div>
            <Trans
              i18nKey="liveconnect.detail.privacy.error"
              components={{ 1: <b /> }}
            />
          </div>
        </div>
      )}
      <ContentTable
        title={t('liveconnect.detail.privacy.table.title')}
        emptyText={t('liveconnect.detail.privacy.table.empty')}
        columns={columns}
        data={privacyPoliciesSigned}
      />
    </div>
  )
}

export default LCTPrivacy
